import { EntityId } from 'entities-next/common'
import React, { useCallback, useEffect, useState } from 'react'
import { FormHelpers, FormManager } from 'utils-next/forms'

import { ApiCorporateData, Corporate } from '../../../../../../../../entities-next/corporate'
import { newCorporate } from '../../../../../../../../entities-next/corporate/corporate.helpers'
import { getApiUserGroupHandlers, UserGroup } from '../../../../../../../../entities-next/userGroup'
import { LoadingScreen } from '../../../../../../components-next/Loading'
import {
  corporateDataFormValidationSchema,
  CorporateFormData,
  parseCorporateFormDataToCorporate,
  parseCorporateToCorporateFormData,
} from './CorporateDataForm.data'
import { CorporateDataFormContent } from './CorporateDataFormContent.component'

export type CorporateDataFormProps = {
  corporate: Corporate
  onSubmit: (userId: EntityId, data: ApiCorporateData) => Promise<void>
  actionBarRef: React.MutableRefObject<any>
}

export function CorporateDataForm({ corporate, onSubmit, actionBarRef }: CorporateDataFormProps) {
  const submitHandler = useCorporateDataFormSubmitHandler(corporate.id, onSubmit)

  const { apiGetUserGroup } = getApiUserGroupHandlers()
  const [userGroup, setUserGroup] = useState<UserGroup | null>(null)
  useEffect(() => {
    const retrieveData = async () => {
      if (corporate.userGroupId) {
        const ug = await apiGetUserGroup(corporate.userGroupId)
        setUserGroup(ug)
      }
    }
    retrieveData()
  }, [corporate])

  if (!corporate || (corporate.userGroupId && !userGroup)) {
    return <LoadingScreen />
  }

  const initialValues: CorporateFormData = {
    ...parseCorporateToCorporateFormData(corporate ? corporate : newCorporate()),
    userGroup: userGroup ?? '',
  }

  return (
    <FormManager
      validateOnBlur={false}
      validateOnChange={false}
      validationSchema={corporateDataFormValidationSchema}
      initialValues={initialValues}
      onSubmit={submitHandler}
    >
      {(formikProps) => <CorporateDataFormContent actionBarRef={actionBarRef} {...formikProps} />}
    </FormManager>
  )
}

function useCorporateDataFormSubmitHandler(corporateId: EntityId, onSubmit: CorporateDataFormProps['onSubmit']) {
  return useCallback(
    async (data: CorporateFormData, { setSubmitting }: FormHelpers<CorporateFormData>) => {
      setSubmitting(true)
      const corporateData = await parseCorporateFormDataToCorporate(data)
      await onSubmit(corporateId, corporateData)
      setSubmitting(false)
    },
    [onSubmit, corporateId]
  )
}
